import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareTeamManagedAgentsRoute: InvariantJiraRoute = {
	name: 'software-team-managed-agents',
	path: '/jira/software/projects/:projectKey/settings/agents',
	exact: true,
};
